/* ============================================================
   Llorrea tijdlijn — vult zichzelf eenmalig zodra de sectie
   in beeld komt. Werkt zowel met een liggende balk (desktop)
   als met een staande balk (mobiel) via de variabele --p.
   ============================================================ */
(function(){

  function play(root){
    if(root.dataset.lloPlayed === '1') return;
    root.dataset.lloPlayed = '1';

    var track = root.querySelector('[data-track]');
    if(!track) return;
    var cols = track.querySelectorAll('[data-col]');
    if(!cols.length) return;

    var total = parseInt(root.getAttribute('data-duration'), 10) || 2800;
    var steps = cols.length > 1 ? cols.length - 1 : 1;
    var per = total / steps;

    for(var i = 0; i < cols.length; i++){
      (function(index){
        var col = cols[index];
        var fill = col.querySelector('[data-fill]');
        var delay = index * per;

        window.setTimeout(function(){
          col.classList.add('is-on');
        }, index === 0 ? 0 : delay);

        if(fill){
          fill.style.transition = 'width ' + per + 'ms linear, height ' + per + 'ms linear';
          window.setTimeout(function(){
            col.style.setProperty('--p', '100%');
          }, delay + 30);
        }
      })(i);
    }
  }

  function boot(){
    var roots = document.querySelectorAll('[data-llo-timeline]');
    if(!roots.length) return;

    if(!('IntersectionObserver' in window)){
      for(var i = 0; i < roots.length; i++) play(roots[i]);
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          play(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.25 });

    for(var j = 0; j < roots.length; j++){
      if(roots[j].dataset.lloPlayed !== '1') io.observe(roots[j]);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 60); });
})();
